
import { User } from "@/models/user";
import Vue from "vue";
import { CompanyUserService } from "@/services/company-user-service";
import AppSelectUserDevice from "./company/SelectUserDevice.vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			showPassword: false
		};
	},
	props: {
		value: {
			type: Object as () => User,
			required: true
		},
		password: {
			type: String
		}
	},
	computed: {
		langItems():ISelectItem<string>[] {
			return [
				{text: "Nederlands", value: "nl-be"},
				{text: "Français", value: "fr"},
			];
		},
		passwordIcon():string {
			if (this.showPassword){
				return "eye";
			}
			return "eye-slash";
		},
	},
	methods: {
		passwordUpdate(newPassword:string) {
			this.$emit("update:password", newPassword);
		},
		async sendActivationEmail() {
			await CompanyUserService.sendActivationLink(this.value.companyId, this.value);
			this.$wf.notify("Activation email sent.", "info", 3000, "info-circle");
		},
		async disableTwoFactorAuth(){
			let result = await this.$wf.confirm("Are you sure you want to disable two factor authentication? This cannot be undone.", "yes", "no", "Warning", "warning");
			if (!result) return;
			let user = await CompanyUserService.getUser(this.value.companyId, this.value.id);
			user.totpEnabled = false;
			await CompanyUserService.updateUser(user.companyId, user);
			this.value.totpEnabled = false;
		},
		isIpAddressValid(ip:string):boolean{
			let parts = ip.split(".");
			if (parts.length != 4) {
				return false;
			}
			for (let part of parts) {
				if (!/^\d+$/.test(part)) {
					return false;
				}
				let num = parseInt(part);
				if (Number.isNaN(num)){
					return false;
				}
				if (num > 255) {
					return false;
				}
				if (num < 0){
					return false;
				}
			}
			return true;
		}
	},
	components: {
		AppSelectUserDevice
	}
});
